import { client } from "./client";
import interceptors from "./interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getMenu() {
    return client.get("api/menu/data");
}

export default {
    getMenu
};